import {connect} from 'react-redux';
import {StoreState} from 'Store/Reducers';
import Field from 'Components/Organisms/Field/Field';
import {FieldType} from 'Store/FieldManagement/PropTypes';
import React, {useEffect, useState} from 'react';
import useFetch from 'Api/useFetch';
import {useMutation} from 'react-query';
import axios from 'axios';
import {useAuth0} from '@auth0/auth0-react';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';

const Mailer = ({
    id,
    ...props
}: MailerProps) => {
    const { getAccessTokenSilently } = useAuth0();
    const { data: userData } = useFetch(
        '/api/v2.9/users/me'
    );

    const { mutateAsync }: any = useMutation(
        async (data: any) => {
            console.log('MUTATE ASYNC');

            const accessToken = await getAccessTokenSilently();
            const api = axios.create({
                baseURL: API_URL,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            });

            return api.put(`/api/v2.9/outbound_mails`, data).then(i => i.data?.data)
        }
    );

    const { data: emailData } = useFetch(
        `/api/v2.9/outbound_mails/${id}`
    );

    useEffect(() => {
        const reqdata = emailData?.data?.mails?.[0];
        console.log('EMAILdata: ', reqdata);
        setData((data) => ({
            ...data,
            ...reqdata,
            email: reqdata?.receivers || '',
            subject: reqdata?.subject || '',
            body: reqdata?.body || userData?.data?.email_signature,
            sent_by: reqdata?.sent_by || ''
        }));
    }, [emailData?.data]);

    const [data, setData] = useState<any>({
        entity_record_id: id,
        email: '',
        subject: '',
        body: ``,
        sent_by: ''
    });

    // useEffect(() => {
    //     if (userData?.data?.name && data?.body === '') {
    //         setData((data) => ({
    //             ...data,
    //             body: `
    //
    //                 ${userData?.data?.email_signature || ''}
    //             `
    //         }));
    //     }
    // }, [userData?.data?.email_signature]);

    const [debounceTimer, setDebounceTimer] = useState<any>(null);

    const handleChange = (key: string) => (value: string) => {
        clearTimeout(debounceTimer);
        setDebounceTimer(null);

        const newData = {
            ...data,
            [key]: value
        };

        console.log('NEW DATA: ', newData);

        setData(newData);
        setDebounceTimer(setTimeout(() => {
            mutateAsync({
                ...data,
                receivers: [data['email']]
            });
        }, 1000));
    }

    return <div>
        <Field
            isEdit={true}
            type={FieldType.Text}
            value={data.email}
            onChange={handleChange('email')}
            properties={{
                placeholder: 'Emailaddress'
            }}
        />
        <br/>
        <Field
            isEdit={true}
            type={FieldType.Text}
            value={data.subject}
            onChange={handleChange('subject')}
            properties={{
                placeholder: 'Onderwerp'
            }}
        />
        <br/>
        <Field
            isEdit={true}
            type={FieldType.HTML_Editor}
            value={data?.body}
            onChange={handleChange('body')}
            properties={{
                placeholder: 'Bericht'
            }}
        />
    </div>;
};

interface Props {
    id: any
    disableAdd?: boolean
}

const mapState = (state: StoreState, props: Props) => ({
});

const mapDispatch = {

};

type MailerProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Mailer);